import { Text } from '@chakra-ui/react'

import Image from '@/features/Services/components/atoms/Images/HRPolicies'

import { TITLE_H1_STYLE, TITLE_H3_STYLE, PARAGRAPH_STYLE } from './style'

import { Policy } from '@/features/Services/types'

const HREF = 'serviceHRPrivacy'

const TITLE = 'HR Privacy Policy'
const SUBTITLE = 'นโยบายความเป็นส่วนตัวฝ่ายบุคคล'

const PRIMARY_COLOR = '#44CDCB'
const SECONDARY_COLOR = '#ECFAFA'
const LINK_IMAGE = '/images/services/hr/4.png'
const GRADIENT = `linear-gradient(0deg, rgba(68, 205, 203, 0.5) 0%, ${PRIMARY_COLOR} 100%)`

const POLICY: Policy[] = [
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        HR Privacy Policy
        <br />
        นโยบายความเป็นส่วนตัว
        <br />
        ฝ่ายบุคคล
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        สำหรับธุรกิจที่เก็บรวบรวมข้อมูลส่วนบุคคลของ พนักงาน
        หรือประมวลผลข้อมูลส่วนบุคคล ของพนักงานเช่น ชื่อ-นามสกุล ที่อยู่
        เลขบัตรประชาชน ของพนักงานเพื่อใช้ยื่นภาษี หรือประกันสังคม
      </Text>
    ),
    image: '/images/services/hr/hr-header.svg',
    imageAspectRatio: 645 / 652,
    button: {
      label: 'สร้าง Policy ตอนนี้!',
      href: '/create/policy?template=hr_privacy',
      logEvent: {
        ga: { category: TITLE, action: 'Click create policy' },
      },
    },
  },
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        HR Privacy Policy
        <br />
        จำเป็นอย่างไร ?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        เพื่อแจ้งจุดประสงค์และแนวปฏิบัติของการประมวลผลข้อมูลส่วนบุคคลตามพ.ร.บ.
        คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 สำหรับธุรกิจที่มีการเก็บรวบรวม ใช้
        หรือ เปิดเผยข้อมูลส่วนบุคคลของพนักงาน ในระหว่าง กระบวนการคัดเลือก
        สัมภาษณ์ และทำสัญญาจ้าง ต้องจัดทำ นโยบายความเป็นส่วนตัวสำหรับพนักงาน (HR
        Privacy Policy)
      </Text>
    ),
    image: '/images/services/hr/2.png',
    imageAspectRatio: 1,
  },
  {
    title: (
      <Text as="h2" sx={TITLE_H3_STYLE}>
        HR Privacy Policy
        <br />
        ครอบคลุมเรื่องอะไรบ้าง?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        นโยบายความเป็นส่วนตัว (HR Privacy Policy) ครอบคลุมไปถึงการปฏิบัติ
        และมาตรการจัดการ ด้านความปลอดภัยของบริษัท เพื่อคุ้มครองข้อมูล
        ส่วนบุคคลที่ได้เก็บรวบรวม ใช้ หรือ เปิดเผยข้อมูล ส่วนบุคคลของพนักงาน
        และบอกวัตถุประสงค์ ในการนำข้อมูลของ พนักงานไปประมวลผล
        ภายใต้ฐานในการประมวลผลข้อมูลและสิทธิ เกี่ยวกับข้อมูลส่วนบุคคล
      </Text>
    ),
    checkList: [
      'ปรับใช้ได้กับทุกธุรกิจ',
      'สอดคล้องตามกฎหมาย PDPA',
      'สามารถคัดลอกลิงก์ไปใช้ได้เลย',
    ],
    image: <Image />,
  },
]

export default {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  POLICY,
  HREF,
  LINK_IMAGE,
  GRADIENT,
  TITLE,
  SUBTITLE,
}
